module.exports = __webpack_public_path__ + "static/media/staff-help.c1424561.svg";